module.exports = __webpack_public_path__ + "img/76294.768818ea.svg";